<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页 > 机构列表</div>
<!--      <div class="curse-btn" @click="to(`/formsub`)">添加项目</div>-->
    </div>
    <div class="list-content">
      <div class="search-box">
        <div class="search-item">
          <el-input v-model="keyword" placeholder="机构名称"></el-input>
        </div>
        <div class="search-item">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            style="width: 100%"
          >
          </el-date-picker>
        </div>
        <div class="search-item">
          <el-button type="primary" icon="el-icon-refresh" @click="searchreset">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="searchFun">搜索</el-button>
        </div>
      </div>
      <el-table
        :data="list"
        border
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="organ_name"
          label="机构名称">
        </el-table-column>
        <el-table-column
          prop="username"
          label="机构账号">
        </el-table-column>
        <el-table-column
          prop="phone"
          width="160"
          label="机构手机号">

        </el-table-column>
        <el-table-column
          prop="organ_name"
          width="160"
          label="注册时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | time }}
          </template>
        </el-table-column>
        <el-table-column
          prop="organ_name"
          width="160"
          label="最后登录时间">
          <template slot-scope="scope">
            {{ scope.row.update_time | time }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="190">
          <template slot-scope="scope">
            <el-button
              v-if="isTimestampBeforeYear(scope.row.create_time,2026)"
              size="mini"
              @click="lookOld(scope.row)">2025申报</el-button>
            <el-button
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page-box flex justify-center padding-top-sm">
        <el-pagination
          class="page-all margin-bottom"
          background
          @current-change="init"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <editOrgDialog :dialog="dialog" :row="row" @watchState="watchState" />
<!--    <oldDialog :dialogOld="dialogOld" :row="row" @watchState="watchState" />-->
  </div>
</template>
<script>
import {zhDate} from "@/tools";
import {baseURL} from "@/config";
import {getOrganList} from "@/api/admin";
import editOrgDialog  from "@/views/adminhome/common/editOrgDialog";
// import oldDialog  from "@/views/adminhome/common/oldDialog";
export default {
  name: "index",
  data() {
    return {
      dialog:false,
      dialogOld:false,
      row:{},
      zhDate:zhDate,
      baseURL:baseURL,
      list: [],
      keyword:'',
      time: null,
      page:1,
      limit: 10,
      total: 20,
    }
  },
  computed: {
    token() {
      return this.$store.state.admintoken
    },
  },
  components: {editOrgDialog},
  created() {
    this.$emit("setActive", {
      active: 2
    })
    this.init()
  },
  methods: {
    // 获取列表
    async init() {
      console.log(this.time)
      let _data = await getOrganList(
        this.keyword,
        this.time ? this.time[0] :'',
        this.time ? this.time[1] :'',
        this.page,
        this.limit
      );
      if (_data.code === 200) {
        this.list = _data.data.data
        this.total = _data.data.total
      } else {
        this.$message.error(_data.message)
      }
    },

    isTimestampBeforeYear(timestamp, year, isSeconds = false) {
      // 1. 参数校验
      if (typeof timestamp !== 'number' || typeof year !== 'number') {
        throw new Error("时间戳和年份必须是数字");
      }
      if (year < 1970 || year > 9999) {
        throw new Error("年份必须在 1970 到 9999 之间");
      }

      // 2. 统一转换为毫秒级时间戳进行比较
      // 如果标记为秒级，或者数值长度典型为10位(秒)，则转换为毫秒
      let msTimestamp = timestamp;
      if (isSeconds || (timestamp > 0 && timestamp < 10000000000)) {
        msTimestamp = timestamp * 1000;
      }

      // 3. 构建目标年份第一天的 Date 对象
      // new Date(year, 0, 1) 表示该年1月1日 00:00:00 (本地时区)
      // 月份从0开始，所以1月是0
      const targetDate = new Date(year, 0, 1);

      // 4. 获取目标日期的毫秒时间戳
      const targetMsTimestamp = targetDate.getTime();

      // 5. 比较
      return msTimestamp < targetMsTimestamp;
    },

    searchFun(){
      this.page = 1
      this.init()
    },

    searchreset(){
      this.keyword = ''
      this.time = []
      this.page = 1
      this.init()
    },

    lookOld(row){
      window.open(row.link)
    },

    handleEdit(row){
      this.row = row
      this.dialog = true
    },

    watchState(data){
      if(data) {
        this.init()
      }
      this.dialog = false
      this.dialogOld = false
    },

    to(path){
      this.$router.push(path)
    }
  },
  watch: {},
  filters: {
    time(val) {
      return zhDate(val * 1000);
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-item {
        width: 33.3%;
        padding-right: 20px;
        margin-bottom: 20px;
      }
    }


  }
}
</style>


